import './index.scss'
import Swiper from 'swiper/js/swiper.min.js'
import '@fancyapps/fancybox/dist/jquery.fancybox.min'
 
$(document).ready(function () {
  $(".pro-detail-section4 .section4-tabs a").eq(0).addClass('active')
  setIntroH()
});
$(window).resize(function () {
  setIntroH()
});

function setIntroH() {
  let H = $('.pro-detail-tab-links .tab-card .card').height();
  console.log('13', H);
  if (window.screen.width > 1440) {
    $('.pro-detail-section1 .section1-text').css('min-height', H * 0.25);
  } else if (window.screen.width >= 1366 && window.screen.width <= 1440) {
    $('.pro-detail-section1 .section1-text').css('min-height', H * 0.32);
  }else if (window.screen.width >= 992 && window.screen.width < 1366) {
    $('.pro-detail-section1 .section1-text').css('min-height', H*0.4);
  }else if (window.screen.width < 992) {
    $('.pro-detail-section1 .section1-text').css('min-height', 0);
  }

}

//相册切换
$('.section4-tabs a').on('click',function(){
    let index = $(this).index()
    $(this).addClass('active').siblings().removeClass('active')
    $('.section4-list .item').eq(index).show().siblings().hide()
})

//页面滚动监听
var section1 = $('.pro-detail-section1').offset().top - 230; //section1的offset.top
var section2 = $('.pro-detail-section2').offset().top - 230; //section2的offset.top
var section4 = $('.pro-detail-section4').offset().top - 230; //section4的offset.top

var navOffsetTop = $('.pro-detail-tab-links .tabs').offset().top; //nav的offset.top
var beforeScroH = $(document).scrollTop();
$(document).scroll(function () {
  var scroH = $(document).scrollTop(); //滚动高度
  var viewH = $(window).height(); //可见高度
  var contentH = $(document).height(); //内容高度

  //判断页面是上滚还是下滚
  var delta = scroH - beforeScroH;
  if (delta > 0 && scroH > navOffsetTop - 50) {
    $('.pro-detail-tab-links .tabs').removeClass('transform')
  } else if (delta < 0 && scroH > navOffsetTop - 50) {
    $('.pro-detail-tab-links .tabs').addClass('transform')
  }
  beforeScroH = scroH;

  if (scroH > navOffsetTop - 50) {
      $('.pro-detail-tab-links .tabs').addClass('fixed')
      $('.pro-detail-tab-links').addClass('addzw')
  } else {
      $('.pro-detail-tab-links .tabs').removeClass('fixed').removeClass('transform')
      $('.pro-detail-tab-links').removeClass('addzw')
  }

  if (delta > 0) {
    if (scroH >= section1 && scroH < section2) {
      $('.pro-detail-tab-links .tabs .tab-cont a').eq(0).addClass('active').siblings().removeClass('active')
    } else if (scroH >= section2 && scroH < section4) {
      $('.pro-detail-tab-links .tabs .tab-cont a').eq(1).addClass('active').siblings().removeClass('active')
    } else if (scroH >= section4) {
      $('.pro-detail-tab-links .tabs .tab-cont a').eq(2).addClass('active').siblings().removeClass('active')
    }
  } else if (delta < 0){
    if (scroH >= section1 && scroH < section2 - 100) {
      $('.pro-detail-tab-links .tabs .tab-cont a').eq(0).addClass('active').siblings().removeClass('active')
    } else if (scroH >= section2-100 && scroH < section4 - 100) {
      $('.pro-detail-tab-links .tabs .tab-cont a').eq(1).addClass('active').siblings().removeClass('active')
    } else if (scroH >= section4-100) {
      $('.pro-detail-tab-links .tabs .tab-cont a').eq(2).addClass('active').siblings().removeClass('active')
    }
  }
  
});

$('.pro-detail-tab-links .tabs .tab-cont a').on('click',function(){
    let animateTop = 0
    let index = $(this).index()
    switch (index) {
        case 0:
            animateTop = section1;
            break;
        case 1:
            animateTop = section2;
            break;
        case 2:
            animateTop = section4 + 50;
            break;
        // case 3:
        //     animateTop = section4;
        //     break;
        // case 4:
        //     animateTop = section5 + 50;
        //     break;
    }
    $('body,html').animate({
      scrollTop: animateTop
    }, 300)
})